import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { WAREHOUSE_TASK_KIND_LABELS, WAREHOUSE_TASK_TYPE, WarehouseTaskExecutionModeValues, WarehouseTaskKindValues, } from '../types/warehouse-task-type.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for WarehouseTaskType — ordinary config (0036 §4), **not** ledger.
 * Writable via `/pg/v1`, like `DistributionCenter`/`StorageAddress`. Table created by
 * `ensureTable` from this descriptor — no hand DDL (request 0141 §1.1).
 */
export const warehouseTaskTypeDescriptor = {
    name: WAREHOUSE_TASK_TYPE,
    label: 'Tipo de Tarefa de Armazém',
    domain: 'stock',
    collectionPath: 'org/{orgId}/warehouse-task-type',
    pathPatternKeys: { orgId: 'string' },
    version: 3,
    description: 'WMS task type cadastro — N per verb (kind), seeds the queue generation',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        {
            name: 'code',
            label: 'Código',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.CODE,
            description: 'Client-facing identification, e.g. "CONFERÊNCIA CEGA"',
        },
        {
            name: 'name',
            label: 'Nome',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
        },
        {
            name: 'kind',
            label: 'Verbo',
            type: 'enum',
            required: true,
            enumValues: [...WarehouseTaskKindValues],
            enumLabels: WAREHOUSE_TASK_KIND_LABELS,
            description: 'Closed verb the core understands',
        },
        {
            name: 'distributionCenterId',
            label: 'Centro de distribuição',
            type: 'string',
            required: false,
            description: 'Scope — null applies to the whole org',
        },
        {
            name: 'isDefault',
            label: 'Padrão',
            type: 'boolean',
            required: true,
            description: 'Chosen by automatic generation for this (kind, distributionCenterId)',
        },
        {
            name: 'defaultPriority',
            label: 'Prioridade padrão',
            type: 'number',
            required: true,
        },
        {
            name: 'steps',
            label: 'Roteiro',
            type: 'object',
            required: false,
            description: 'WarehouseTaskStep[] — empty/absent = built-in default for kind (request 0147)',
        },
        {
            name: 'executionMode',
            label: 'Formato de execução',
            type: 'string',
            required: false,
            enumValues: [...WarehouseTaskExecutionModeValues],
            description: 'sequential | list — request 0211; absent = sequential',
        },
        {
            name: 'printVolumeLabelsOnFinish',
            label: 'Imprimir etiquetas ao concluir',
            type: 'boolean',
            required: false,
            description: 'Spec 0052 D9 / request 0324 — absent/null = false; requires enter-volumes',
        },
        {
            name: 'version',
            label: 'Versão do roteiro',
            type: 'number',
            required: false,
            description: 'Bumped on edit — carried into the line snapshot (§2.2)',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'distributionCenterId',
            targetEntity: 'DistributionCenter',
            relationship: 'many-to-one',
            displayField: 'name',
        },
    ],
};
//# sourceMappingURL=warehouse-task-type.descriptor.js.map